{
  "failLoadDxmlFile": "(500) Det gick inte att ladda DXML filen",
  "failSaveDocument": "(501) Det gick inte att spara dokumentet",
  "failLoadFile": "(502) Det gick inte att ladda filen",
  "failLoadData": "(503) Det gick inte att ladda data",
  "failSearch": "(504) Det gick inte att söka",
  "failSearchAttachment": "(505) Det gick inte att söka i bilagan",
  "failLoadFileExtension": "(506) Det gick inte att ladda filen eftersom filtillägget ",
  "failLoadFileExtensionIsNotSupport": " inte stöds.",
  "disableDistributionError": "(507) Kan inte publicera dokument. Inaktivera distribution i WebEditor-inställningarna i CenterPoint.",
  "enableDistributionError": "(508) Kan inte publicera dokument. Vänligen aktivera distribution i WebEditor-inställningarna i CenterPoint.",
  "selectFileTooLarge": "(509) Den valda filen är för stor. Den maximala filstorleken är 1 MB.",
  "inactiveDistributionList": "(510) Distributionslistan i Pages manager är inte aktiverad.",
  "noActiveDistributionAlternatives": "(511) Distributionslistan i Page manager har inga aktiva distributionsalternativ.",
  "publishErrorMsg": "(513) Dokumentet kan inte publiceras på grund av ogiltig eller ofullständig information i ett eller flera fält."
}